;(() => {
  let redeemPikadayInstance = null
  const redeemVoucherModalContent = document.querySelector(
    '.redeem-voucher-modal-content'
  )

  if (redeemVoucherModalContent) {
    const modal = document.querySelector('section#modal')

    document.querySelectorAll('a[href*="#redeem-voucher"]').forEach((link) => {
      link.addEventListener('click', function (event) {
        event.preventDefault()
        modal.classList.add('active', 'tight')
        modal.querySelector('main.wrapper').innerHTML =
          redeemVoucherModalContent.innerHTML
        modal.querySelector('input[name="voucher"]').focus()
        bindEventHandler(modal.querySelector('form#redeem-voucher'))
      })
    })

    //open modal if url contains this hash
    if (window.location.hash === '#redeem-voucher') {
      document.querySelector('nav.main-menu a[href="#redeem-voucher"]')?.click()
    }

    function formatDate(dateString) {
      const date = new Date(dateString)
      const day = date.getDate()
      const month = date.toLocaleString('en-GB', { month: 'long' })
      const year = date.getFullYear()

      return `${day} ${month} ${year}`
    }

    //this is required to bind event handler after the element has been added to the modal
    function bindEventHandler(form) {
      const step1 = form.querySelector('.step[data-step="1"]')
      const voucherError = form.querySelector('#voucher-error')
      const dispatchDateError = form.querySelector('#dispatch-date-error')
      const step2 = modal.querySelector('.step[data-step="2"]')
      const step1Button = step1.querySelector('button#submit-voucher')

      // Function to handle step 1 voucher validation
      const handleStep1Submission = async function () {
        try {
          const form_values = Object.fromEntries(new FormData(form))
          const { voucher } = form_values

          if (!voucher) {
            voucherError.innerHTML = 'Please Enter a Voucher.'
            return
          } else {
            voucherError.innerHTML = ''
          }

          const response = await fetch(
            `https://app.insectlore.co.uk/api/v1/vouchers/check`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                voucher_code: voucher.trim()
              }),
              signal: AbortSignal.timeout(5000)
            }
          )
          const responseJson = await response.json()

          //product id is required to get product metafield with dispatch dates, you can't get a variant with a variant ID using the shopify storefront API
          const { product_id, error } = responseJson

          if (!error) {
            voucherError.innerHTML = ''
            step1.hidden = true
            step2.hidden = false
            initDatePicker(form, product_id)
          } else {
            voucherError.innerHTML = error.message
          }
        } catch (error) {
          console.error('Error Checking Voucher: ', error)
          if (error.name === 'TimeoutError') {
            voucherError.innerHTML =
              'Could not reach the voucher redemption service. Please try again later.'
          } else {
            voucherError.innerHTML = error.message
          }
          if (window.Sentry) {
            Sentry.captureException(error, {
              tags: { function: 'checkVoucher' }
            })
          }
        }
      }

      step1Button.addEventListener('click', handleStep1Submission)

      form.addEventListener('submit', async function (event) {
        event.preventDefault()

        // If step 1 is visible, trigger step 1 validation instead of submitting
        if (!step1.hidden) {
          await handleStep1Submission()
          return
        }

        // Only proceed with actual submission if step 2 is visible
        if (!step2.hidden) {
          const form_values = Object.fromEntries(new FormData(this))
          const { dispatch_date, voucher } = form_values

          // Validate that a dispatch date has been selected
          if (!dispatch_date) {
            dispatchDateError.innerHTML = 'Please select a dispatch date.'
            return
          } else {
            dispatchDateError.innerHTML = ''
          }

          try {
            const response = await fetch(
              `https://app.insectlore.co.uk/api/v1/vouchers/redeem`,
              {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                  voucher_code: voucher.trim()
                })
              }
            )
            const responseJson = await response.json()
            const {
              product_id,
              variant_id,
              sku,
              voucher_code,
              redemption_fee,
              hash
            } = responseJson

            await ifItemAlreadyInCartWithVoucherRemoveIt(voucher_code)
            await window.addProductToCart({
              variantId: variant_id,
              sku: sku,
              quantity: 1,
              dispatchDate: dispatch_date,
              voucher: voucher_code,
              redemptionFee: redemption_fee,
              hash: hash
            })

            await addAttributeToCart({ redeeming_voucher: true })

            //when on any page except the cart template, update the cart drawer, otherwise refresh the cart page after the voucher product has been added to the cart
            if (!document.querySelector('html.template-cart')) {
              await updateCartDrawer()
              await new Promise((x) => setTimeout(x, 100)) //this is used to ensure the open-cart transition works. without it the transition is skipped
              openCartDrawer()
              document.querySelector('.modal-background').click() //close the redeem voucher modal
            } else {
              window.location.reload(true)
            }

            updateHeaderCartCount()
          } catch (error) {
            console.error('Error Submitting Voucher: ', error)
            dispatchDateError.innerHTML = 'Error Submitting Voucher'
            if (window.Sentry) {
              Sentry.captureException(error, {
                tags: { function: 'redeemVoucher' }
              })
            }
          }
        }
      })
    }
  }

  //if product with this voucher already in cart, remove it before re-adding with the newly selected date
  //this scenario can happen if the customer enters the voucher and adds the product to their basket, but then
  //doesn't continue to the checkout, the voucher will update after 30 minutes and is eligible to be re-added
  async function ifItemAlreadyInCartWithVoucherRemoveIt(voucher) {
    const res = await fetch(`${window.Shopify.routes.root}cart.json`)
    const cart = await res.json()
    const productWithVoucherAlreadyInCart = cart.items.find(
      (item) => item.properties?._voucher === voucher
    )

    if (productWithVoucherAlreadyInCart) {
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {
            [productWithVoucherAlreadyInCart.key]: 0
          }
        })
      })
    }
  }

  async function initDatePicker(form, product_id) {
    try {
      const allowedDates = await window.getProductDispatchDates(product_id)

      if (allowedDates.length === 0) {
        form.querySelector('#dispatch-date-error').innerHTML =
          'No dispatch dates available'
        return
      }

      const allowedDateSet = new Set(allowedDates.map(window.toDateKey))
      const firstAvailableDate = allowedDates[0]
      const addToBasketButton = form.querySelector(
        'footer.redeem-voucher-modal-date-footer button#add-variant-to-basket'
      )

      if (redeemPikadayInstance) {
        redeemPikadayInstance.destroy()
      }

      redeemPikadayInstance = new Pikaday({
        field: form.querySelector('input#dispatch-date-picker-1'),
        bound: false,
        container: form.querySelector('#calendar-container-1'),
        minDate: firstAvailableDate,
        firstDay: 1, //set first day to a Monday
        onSelect: function (date) {
          function formatDate(dateString) {
            const date = new Date(dateString)
            const day = date.getDate()
            const month = date.toLocaleString('en-GB', { month: 'long' })
            const year = date.getFullYear()
            return `${day} ${month} ${year}`
          }
          const formattedDate = new Intl.DateTimeFormat('en-GB').format(date)
          form.querySelector('input#dispatch-date-picker-1').value =
            formattedDate
          form.querySelector('#dispatch-date-message-1').hidden = false
          form.querySelector('span#dispatch-date-string-1').textContent =
            formatDate(date)
          // Enable the Add to Basket button when a date is selected
          addToBasketButton.disabled = false
          // Focus the button so Enter key will work
          addToBasketButton.focus()
        },
        disableDayFn: function (date) {
          return !allowedDateSet.has(window.toDateKey(date))
        },
        onOpen: function () {
          this.gotoDate(firstAvailableDate) // Show the correct month
        }
      })

      // Show button but keep it disabled until a date is selected
      addToBasketButton.hidden = false
      addToBasketButton.disabled = true
    } catch (error) {
      form.querySelector('#dispatch-date-error').innerHTML = error.message
      console.error('Error Initing Date Picker: ', error)
      if (window.Sentry) {
        Sentry.captureException(error, { tags: { function: 'initDatePicker' } })
      }
    }
  }
})()
